import { useEffect, useState } from "react";
import InputAHSF from "../../../Components/InputAHSF";
import "./style.css";
import {
  AddObObjectives,
  EditObjectivesById,
  GetObjectivesById,
  GetObObjectives,
} from "../../../Redux/Reducers/BudgetInformation/Objectives";
import { useDispatch, useSelector } from "react-redux";
import ButtonAHSF from "../../../Components/ButtonAHSF";
import $ from "jquery";
import { setRefreshTable } from "../../../Redux/Reducers/VariousVariables";
import LoaderAHSF from "../../../Components/LoaderAHSF";
import Swal from "sweetalert2";

const AddEdit_Objectives = (props) => {
  const dispatch = useDispatch();
  const [objectiveName, setObjectiveName] = useState(null);
  // const [schumannsContribution, setSchumannsContribution] = useState(null)
  // const [schumannsContributionValidation, setSchumannsContributionValidation] = useState(null)

  const [
    definitionOfMeasurementIndicator,
    setDefinitionOfMeasurementIndicator,
  ] = useState(null);
  const [baseValueOrtargetValue, setBaseValueOrtargetValue] = useState(null);
  const [targetValue, setTargetValue] = useState(null);
  const [validationOpject, setValidationOpject] = useState();
  let Objectives = useSelector((state) => state.objectives.Objectives);
  const lodingGetObjectives = useSelector(
    (state) => state.objectives.loadingDeleteObjectives
  );
  const [objectiveNameValidate, SetobjectiveNameValidate] = useState(false);
  // Function to add new objectives
  const addObjectives = () => {

    let StatusValidation=true
  
    if(objectiveName != null && objectiveName != ""){
      StatusValidation=true
      SetobjectiveNameValidate(false);

    }else{
      StatusValidation=false
      SetobjectiveNameValidate(true);
    }
    // if(schumannsContribution != null && schumannsContribution != ""){
    //   StatusValidation=true
    //   setSchumannsContributionValidation(false)
    // }else{
    //   StatusValidation=false
    //   setSchumannsContributionValidation(true)
    // }

    if (StatusValidation) {
     
      dispatch(
        AddObObjectives({
          objectiveName: objectiveName, // Objective name to be added
          aI_ApplicationInformationId: localStorage.getItem(
            "aI_ApplicationInformationId",
            // Retrieve application information ID from localStorage
          ),
          // schumannsContribution: parseFloat(schumannsContribution) 
        })
      );

      dispatch(setRefreshTable()); // Refresh table to reflect new data
      $(".close-btn").trigger("click"); // Simulate click to close modal

      Swal.fire({
        position: "center",
        icon: "success",
        title: "تم اضافة المعلومات بنجاح", // Success message in Arabic
        showConfirmButton: false,
        timer: 1500, // Auto-close after 1.5 seconds
      });
    } 
  };

  // Function to edit existing objectives
  const editObjectives = () => {
    let StatusValidation=true
  
    if(objectiveName != null && objectiveName != ""){
      StatusValidation=true
      SetobjectiveNameValidate(false);

    }else{
      StatusValidation=false
      SetobjectiveNameValidate(true);
    }
    // if(schumannsContribution != null && schumannsContribution != ""){
    //   StatusValidation=true
    //   setSchumannsContributionValidation(false)
    // }else{
    //   StatusValidation=false
    //   setSchumannsContributionValidation(true)
    // }


    if (StatusValidation) {
      SetobjectiveNameValidate(false); // Reset validation state

      dispatch(
        EditObjectivesById({
          bI_ObjectivesId: Objectives?.bI_ObjectivesId, // ID of the objective to edit
          objectiveName: objectiveName, // Updated objective name
          aI_ApplicationInformationId: localStorage.getItem(
            "aI_ApplicationInformationId" // Retrieve application information ID from localStorage
          ),
          // schumannsContribution: parseFloat(schumannsContribution) 
        })
      );

      dispatch(setRefreshTable()); // Refresh table to reflect updates

      Swal.fire({
        position: "center",
        icon: "success",
        title: "تم تعديل المعلومات بنجاح", // Success message in Arabic
        showConfirmButton: false,
        timer: 1500, // Auto-close after 1.5 seconds
      });

      $(".close-btn").trigger("click"); // Simulate click to close modal
    } 
  };

  // Effect to fetch objective details when props are updated
  useEffect(() => {
    if (props != null) {
      dispatch(GetObjectivesById({ bI_ObjectivesId: props.bI_ObjectivesId })); // Fetch objective by ID
      setObjectiveName(Objectives?.objectiveName); // Set objective name in state
    }
  }, [props.bI_ObjectivesId]); // Runs when `bI_ObjectivesId` in props changes

  // Effect to handle loading and viewing/editing objectives
  useEffect(() => {
    if (
      (!lodingGetObjectives && props.Action == "edit") || // When action is "edit" and data is loaded
      props.Action == "view" // When action is "view"
    ) {
      setObjectiveName(Objectives?.objectiveName); // Set objective name in state
    } else if (props.Action == undefined) {
      setObjectiveName(null); // Reset objective name
      Objectives = null; // Reset objectives
    }
  }, [Objectives]); // Runs when `Objectives` in state changes

  //render html
  return (
    <div className="containerAddEdit_Objectives">
      <LoaderAHSF show={lodingGetObjectives} />
      {((props.Action == "edit" || props.Action == "view") && Objectives) ||
        props.Action == undefined ? (
        <>
          <div className="onerow">
            <InputAHSF
              fieldsName="objectiveName"
              show={true}
              disabled={props.disabledData ? true : false}
              defaultValue={
                props.Action == "view" || props.Action == "edit"
                  ? Objectives?.objectiveName
                  : // objectiveName
                  ""
              }
              onChange={(e) => {
                setObjectiveName(e.target.value);
              }}
              showValidationMessage={objectiveNameValidate}
              validationMessage={"حقل اجباري"}
            />
          </div>
          {/* <div className="onerow">
            <InputAHSF
              fieldsName="schumannsContribution"
              show={true}
              comma={true}
              disabled={props.disabledData ? true : false}
              defaultValue={
                props.Action == "view" || props.Action == "edit"
                  ? Objectives?.schumannsContribution
                  : // objectiveName
                  ""
              }
              onChange={(e) => {
                console.log(e.target.value,"sdsdsdsdwd");
                
                setSchumannsContribution(parseFloat(e.target.value));
              }}
              showValidationMessage={schumannsContributionValidation}
              validationMessage={"حقل اجباري"}
            />
          </div> */}
          <div className="containerButton">
            {props.Action == "view" ? (
              <></>
            ) : (
              <>
                <ButtonAHSF
                  onClick={
                    props.Action == "edit" ? editObjectives : addObjectives
                  }
                  text={"حفظ"}
                  show={true}
                />
              </>
            )}
          </div>
        </>
      ) : (
        ""
      )}
    </div>
  );
};

export default AddEdit_Objectives;
